import { mapGetters, mapActions } from 'vuex'
import siteTab from '@/components/tab'
import journal from '@/api/journal'
export default {
  components: {
    siteTab
  },
  data() {
    return {
      menus: [
        {
          name: 'Basic Information',
          href: '/publishing/journal-website/basic-information',
          code: 'WEBSITE.JOURNAL_WEBSITE.BASIC_INFORMATION'
        },
        {
          name: 'Journal Menu',
          href: '/publishing/journal-website/journal-menu',
          code: 'WEBSITE.JOURNAL_WEBSITE.POLICY'
        },
        {
          name: 'Sections',
          href: '/publishing/journal-website/sections',
          code: 'WEBSITE.JOURNAL_WEBSITE.SECTIONS'
        },
        {
          name: 'Highlights',
          href: '/publishing/journal-website/highlights',
          code: 'WEBSITE.JOURNAL_WEBSITE.BANNER'
        },
        {
          name: 'Announcement',
          href: '/publishing/journal-website/announcement',
          code: 'WEBSITE.JOURNAL_WEBSITE.ANNOUNCEMENT'
        },
        {
          name: 'Conferences',
          href: '/publishing/journal-website/conferences',
          code: 'WEBSITE.JOURNAL_WEBSITE.CONFERENCES'
        }
        // {
        //   name: 'Key Relationship',
        //   href: '/publishing/journal-website/social-collabrations',
        //   code: 'WEBSITE.JOURNAL_WEBSITE.COLLABORATION'
        // },
        // {
        //   name: 'Database',
        //   href: '/publishing/journal-website/database',
        //   code: 'WEBSITE.JOURNAL_WEBSITE.DATABASE'
        // }
      ],
      journals: [],
      currentJournal: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage',
      journalId: 'getJournalId'
    })
  },
  watch: {
    user: {
      handler() {
        this.redict()
      },
      immediate: true
    },
    $route() {
      this.redict()
    }
  },
  mounted() {
    this.getJournal()
  },
  methods: {
    ...mapActions(['updateJournalId', 'updatePersonalJournalList']),
    async getJournal() {
      this.journals = await journal.userGet()
      const flag = this.journals.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.currentJournal = item.id
          return true
        }
      })
      if (!flag) {
        if (this.journals[0]) {
          this.currentJournal = this.journals[0].id
        }
        localStorage.setItem('journalId', this.currentJournal)
      }
      this.onJournalChange(this.currentJournal)
      this.updatePersonalJournalList(this.journals)
    },
    onJournalChange(val) {
      localStorage.setItem('journalId', val)
      this.updateJournalId(val)
    },
    redict() {
      if (this.$route.path !== '/publishing/journal-website') {
        return
      }
      this.menus.some(item => {
        if (this.user.codeList && this.user.codeList.includes(item.code)) {
          this.$router.replace(item.href)
          return true
        }
      })
    }
  }
}
